import React from "react";
import "./imageModal.css"; // Make sure to import this CSS file

const ImageModal = ({ imageUrl, onClose }) => {
  if (!imageUrl) return null;

  return (
    <div
      onClick={onClose}
      className="image-modal-backdrop"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="image-modal-content"
      >
        <img
          src={imageUrl}
          alt="Popup"
          className="modal-image"
        />
        <button
          onClick={onClose}
          className="close-button"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ImageModal;
